import React from 'react';

function FieldError(props) {
    const { message, ...rest } = props;
    return (
        <div className="text-red text-sm my-1" {...rest}>{message}</div>
    );
}

export default FieldError;
